import ListarUsuariosSistema from "views/ListarUsuariosSistema.jsx";
import CrearUsuarioSistema from "views/CrearUsuarioSistema.jsx";
import Consultantes from "views/ListarConsultantes.jsx";
import Actividades from "views/Actividades.jsx";
import Reportes from "views/Reportes.js";
import Login from "views/Login.jsx";
import Recuperar from "views/Recuperar.jsx";
import FichaUsuarioConsultante from "views/FichaUsuarioConsultante.jsx"

import EditarUsuarioSistema from "views/EditarUsuarioSistema.jsx";
import ActualizarContrasena from "views/ActualizarContrasena";
import IngresarUsuarioConsultante from "views/IngresarUsuarioConsultante.jsx"
import EditarSesion from "views/EditarSesion.jsx"
import EditarActividad from "views/EditarActividad.jsx"
import EditarActividadFecha from "views/EditarActividadFecha.jsx"
import Proyectos from "views/Proyectos.jsx"
import EditarProyecto from "views/EditarProyecto.jsx"

import ListaMaestra from "views/ListaMaestra.jsx"

import Asistencia from "views/Asistencia.jsx"
import RegistroAsistencia from "views/RegistroAsistencia.jsx"
import ConsultantesHistorico from "views/ListarConsultantesHistorico.jsx";
import EditarParticipacionGrupal from "views/EditarParticipacionGrupal.jsx"

import AgendaCompartida from "views/AgendaCompartida";

const dashboardRoutes = [
{
    path: "/Login",
    name: "Login",
    icon: "nc-icon nc-circle-09",
    component: Login,
    layout: "",
    ismenu: false
},
{
    path: "/Recuperar",
    name: "Recuperar",
    icon: "nc-icon nc-circle-09",
    component: Recuperar,
    layout: "",
    ismenu: false
},
{
    path: "/ActualizarContrasena",
    name: "ActualizarContrasena",
    icon: "nc-icon nc-circle-09",
    component: ActualizarContrasena,
    layout: "/admin",
    ismenu: false
},
{
    path: "/ListarUsuariosSistema",
    name: "Administración",
    icon: "nc-icon nc-circle-09",
    component: ListarUsuariosSistema,
    layout: "/admin",
    ismenu: true
},
{
    path: "/EditarUsuarioSistema",
    name: "Editar Usuario",
    icon: "nc-icon nc-chart-pie-35",
    component: EditarUsuarioSistema,
    layout: "/admin",
    ismenu: false
},
{
    path: "/CrearUsuarioSistema",
    name: "Crear Usuario",
    icon: "nc-icon nc-chart-pie-35",
    component: CrearUsuarioSistema,
    layout: "/admin",
    ismenu: false
},
{
    path: "/FichaUsuarioConsultante",
    name: "Ficha",
    icon: "nc-icon nc-chart-pie-35",
    component: FichaUsuarioConsultante,
    layout: "/admin",
    ismenu: false
},
{
    path: "/IngresarUsuarioConsultante",
    name: "IngresarConsultante",
    icon: "nc-icon nc-chart-pie-35",
    component: IngresarUsuarioConsultante,
    layout: "/admin",
    ismenu: false
},
{
    path: "/EditarSesion",
    name: "EditarSesion",
    icon: "nc-icon nc-chart-pie-35",
    component: EditarSesion,
    layout: "/admin",
    ismenu: false
},
{
  path: "/EditarParticipacionGrupal",
  name: "EditarParticipacionGrupal",
  icon: "nc-icon nc-chart-pie-35",
  component: EditarParticipacionGrupal,
  layout: "/admin",
  ismenu: false
},
{
    path: "/ListarConsultantes",
    name: "Consultantes",
    icon: "nc-icon nc-badge",
    component: Consultantes,
    layout: "/admin",
    ismenu: true
},
{
    path: "/Actividades",
    name: "Actividades",
    icon: "nc-icon nc-notes",
    component: Actividades,
    layout: "/admin",
    ismenu: true
  },
  {
    path: "/EditarActividad",
    name: "EditarActividad",
    icon: "nc-icon nc-chart-pie-35",
    component: EditarActividad,
    layout: "/admin",
    ismenu: false
},
{
    path: "/EditarActividadFecha",
    name: "EditarActividadFecha",
    icon: "nc-icon nc-chart-pie-35",
    component: EditarActividadFecha,
    layout: "/admin",
    ismenu: false
},
{
    path: "/Proyectos",
    name: "Proyectos",
    icon: "nc-icon nc-bag",
    component: Proyectos,
    layout: "/admin",
    ismenu: true
},
{
    path: "/EditarProyecto",
    name: "EditarProyecto",
    icon: "nc-icon nc-bag",
    component: EditarProyecto,
    layout: "/admin",
    ismenu: false
},
  
  {
    path: "/AgendaCompartida",
    name: "Agenda",
    icon: "nc-icon nc-time-alarm",
    component: AgendaCompartida,
    layout: "/admin",
    ismenu: true
  },
  
  {
    path: "/ListaMaestra",
    name: "Lista Maestra",
    icon: "nc-icon nc-layers-3",
    component: ListaMaestra,
    layout: "/admin",
    ismenu: true
  },
  {
    path: "/RegistroAsistencia",
    name: "Registro Asistencia",
    icon: "nc-icon nc-check-2",
    component: RegistroAsistencia,
    layout: "/admin",
    ismenu: true
  },
  {
    path: "/Asistencia",
    name: "Asistencia",
    icon: "nc-icon nc-chart-bar-32",
    component: Asistencia,
    layout: "/admin",
    ismenu: true
  },
  {
    path: "/ListarConsultantesHistorico",
    name: "ConsultantesHistorico",
    icon: "nc-icon nc-paper-2",
    component: ConsultantesHistorico,
    layout: "/admin",
    ismenu: false
}

  
];

export default dashboardRoutes; 
